import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CommonDatePicker = ({ fromDate, setFromDate, toDate, setToDate }) => {
  return (
    <>
      <div className="col-md-2">
        <label className="form-label">From Date</label>
        <DatePicker
          selected={fromDate}
          onChange={(date) => setFromDate(date)}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select from date"
        />
      </div>

      {/* To Date */}
      <div className="col-md-2 ">
        <label className="form-label">To Date</label>
        <DatePicker
          selected={toDate}
          onChange={(date) => setToDate(date)}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select to date"
          minDate={fromDate} // prevent selecting before fromDate
        />
      </div>
    </>
  );
};

export default CommonDatePicker;
